export default "__VITE_ASSET__4Xr_fl7l__"